<template>
  <section class="hr">
    <div class="titArea">
      <h3 class="titH4">추천 상품</h3>
    </div>
    <div class="slide goodsList" id="slide3">
      <ul class="slideList">
        <li v-for="(productRecommendList, index) in productRecommend" :key="index">
          <a
            @click="
              pageMove(
                'af_PDP_recommended_product',
                '/product/category/detail/' + productRecommendList.productIndex,
                productRecommendList.productIndex,
              )
            "
            class="block"
          >
            <span class="img imgCover">
              <img :src="productRecommendList.thumbnail" :alt="productRecommendList.displayName" />
            </span>
            <em class="tit row2">{{ productRecommendList.displayName }}</em>
            <p class="desc">{{ productRecommendList.modelCode }}</p>
            <p class="price">
              <span class="money">{{ productRecommendList.cardDcAmount | currency }}</span>
              원~/제휴카드가
            </p>
          </a>
        </li>
      </ul>
      <div class="swiper-scrollbar"></div>
    </div>
  </section>
</template>

<script>
import * as customjs from '@/../static/js/m.front.js';
export default {
  name: 'ProductDetailRecommend',
  props: ['productRecommend', 'productIndex'],
  updated() {
    // TODO 추천 상품 내역 업데이트 필요
    // console.log('추천상품');
    // console.log(this.productRecommend);
    customjs.slideInit('#slide3', 0, false, 500, false, 'auto', 10);
  },
  methods: {
    pageMove(type, url, content, query) {
      const params = {
        af_origin_id: this.productIndex,
        af_content_id: content,
      };
      window.appsFlyer(type, params);

      if (query != null) {
        this.$router.push({ name: url, query });
      } else {
        this.$router.push(url);
      }
    },
  },
};
</script>
